export const sortSizes = (sizes) => {
  const humanSizes = ['XS', 'S', 'S/M', 'M', 'L', 'L/XL', 'XL', 'XXL', 'E'];
  const finalSizesSorted = [];
  const foundHumanSizes = [];
  const foundNumericSizes = [];

  // remove human sizes
  sizes.forEach((s) => {
    if (Number.isNaN(parseInt(s, 10))) {
      foundHumanSizes.push(s.toUpperCase());
    } else {
      foundNumericSizes.push(parseInt(s, 10));
    }
  });

  humanSizes.forEach((s) => {
    if (foundHumanSizes.indexOf(s) > -1) {
      finalSizesSorted.push(s);
    }
  });

  foundNumericSizes
    .sort((a, b) => a - b)
    .forEach((s) => {
      finalSizesSorted.push(s.toString());
    });

  return finalSizesSorted;
};
